const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const WEEK_MS = 7 * DAY_MS;
const MONTH_MS = 30 * DAY_MS;
const YEAR_MS = 365 * DAY_MS;

export function formatInboxV2Timestamp(value: string | Date) {
  const date = parseDate(value);

  if (!date) {
    return "";
  }

  const diffMs = Date.now() - date.getTime();

  if (diffMs < DAY_MS) {
    return formatTime(date);
  }

  if (diffMs < WEEK_MS) {
    return formatUnit(Math.floor(diffMs / DAY_MS), "day");
  }

  if (diffMs < MONTH_MS) {
    return formatUnit(Math.floor(diffMs / WEEK_MS), "week");
  }

  if (diffMs < YEAR_MS) {
    return formatUnit(Math.floor(diffMs / MONTH_MS), "month");
  }

  return formatUnit(Math.floor(diffMs / YEAR_MS), "year");
}

export function formatInboxV2TimestampWithAgo(value: string | Date) {
  const label = formatInboxV2Timestamp(value);

  if (!label || /\b(?:am|pm)$/i.test(label)) {
    return label;
  }

  return `${label} ago`;
}

export function formatInboxV2ExactTimestamp(value: string | Date) {
  const date = parseDate(value);

  if (!date) {
    return "";
  }

  return `${date.getDate()} ${date.toLocaleString("en-US", {
    month: "short",
  })} ${date.getFullYear()}, ${formatTime(date)}`;
}

function parseDate(value: string | Date) {
  const date = value instanceof Date ? value : new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
}

function formatTime(date: Date) {
  return date
    .toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .toLowerCase();
}

function formatUnit(value: number, unit: string) {
  const count = Math.max(1, value);

  return `${count} ${unit}${count === 1 ? "" : "s"}`;
}
